import React from "react";
import { makeStyles } from '@material-ui/styles';
import { ExpansionPanelDetails } from '@material-ui/core';
import { ExpansionPanel } from '@material-ui/core';
import { ExpansionPanelSummary } from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PersonOutline from "@material-ui/icons/PersonOutline";
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
  } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    GridQ:{
        paddingLeft: theme.spacing(3),
        paddingTop:theme.spacing(3)
    },
    GridA:{
        paddingLeft: theme.spacing(3),
        paddingTop:theme.spacing(1)
    },
    TextUserName:{
        paddingTop:theme.spacing(0.5)
    }

  }));

  const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );

const QuestionCard = (props) => {

    const classes = useStyles();

    return ( <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="h6" gutterBottom>
            {props.Header}
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
            <Card className={classes.cardsMax} style={{width:"100%"}}>
                    <Grid container spacing={1} className={classes.GridQ}>
                     <Grid item>
                       <PersonOutline />
                      </Grid>
                      <Grid item>
                      <Typography style={{fontWeight:'bold'}} className={classes.TextUserName} variant="overline" display="block" gutterBottom>
                      {props.QuestionUser}
                      </Typography>
                      </Grid>
                      <Grid item>
                      <Typography variant="overline" display="block" className={classes.TextUserName} gutterBottom>
                          {bull}  {props.QuestionDate}
                      </Typography>
                        </Grid>
                    </Grid>
                    <CardContent>
                    <Typography variant="body2" gutterBottom>
                         {props.Question}
                    </Typography>
                    </CardContent>
                    <Grid container spacing={1} className={classes.GridA}>
                    <Grid item>
                       <AccountCircle style={{color:'blue'}} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.TextUserName} style={{fontWeight:'bold',color:'blue'}}  variant="overline" display="block" gutterBottom>
                         {props.AnswerUser}
                      </Typography>
                      </Grid>
                      <Grid item>
                      <Typography className={classes.TextUserName} style={{color:'blue'}} variant="overline" display="block" gutterBottom>
                      {bull}  {props.AnswerDate}
                      </Typography>
                        </Grid>
                    </Grid>
                    <CardContent>
                    <Typography variant="body2" gutterBottom>
                         {props.Answer}
                    </Typography>
                    </CardContent>
             </Card>
      </ExpansionPanelDetails>
    </ExpansionPanel>);
  }

  export default QuestionCard;
